import ChangeMasterPasswordModal from "./ChangeMasterPassword";
import ConfirmEncryptionUpdateModal from "./ConfirmEncryptionUpdate";

const securityModalsComponents = {
  ChangeMasterPasswordModal,
  ConfirmEncryptionUpdateModal
}

export default securityModalsComponents;